/**
 * Onde a caixa de busca da tela de menções procura (2026-10-14) —
 * espelho de `core.vocabulary.MENTION_SEARCH_FIELDS`, com paridade
 * travada por `tests/test_mention_search_field_parity.py` (lê este
 * arquivo, inclusive a SEQUÊNCIA, que é a ordem do `<select>`). O mapa de
 * rótulos é tipado sobre a tupla de propósito: chave a menos ou a mais é
 * erro de compilação, não uma opção sem nome na tela.
 */

export const MENTION_SEARCH_FIELDS = ["all", "title", "content"] as const;

export type MentionSearchField = (typeof MENTION_SEARCH_FIELDS)[number];

export const MENTION_SEARCH_FIELD_DEFAULT: MentionSearchField = "all";

export const MENTION_SEARCH_FIELD_LABELS: Record<MentionSearchField, string> = {
  all: "Tudo",
  title: "Título",
  content: "Conteúdo"
};
